<template>
  <div>
    <v-btn
      v-if="circle"
      v-tooltip.top="$t('Print Cover')"
      outline
      :loading="loading"
      :disabled="loading"
      small
      fab
      color="primary"
      @click="getShopProfile"
    >
      <span class="fa fa-print"></span>
    </v-btn>
    <v-btn
      v-else
      :loading="loading"
      :disabled="loading || orders.length == 0"
      outline
      color="grey"
      @click="getShopProfile"
    >
      <v-icon>fa fa-print</v-icon>
      &nbsp;{{ $t('Print Covers') }}
    </v-btn>
    <v-dialog v-model="showEditAddress" width="800" persistent>
      <v-card v-if="showEditAddress">
        <v-card-text>
          <div style="text-align: right">
            <v-btn icon @click="cancelEdit">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <label for="pageAddress">{{ $t('Shop Address') }}</label>

          <shipping-address></shipping-address>
          <div class="text-xs-center mt-3">
            <v-btn outline color="grey" @click="skipEdit">{{ $t('skip') }}</v-btn>
            <v-btn
              :loading="loadingsave"
              depressed
              color="primary"
              :disabled="!addresses || addresses.length == 0"
              @click="saveContent"
            >
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrintAllCovers from './PrintAllCovers.js'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import moment from 'moment'
import { seagull } from './seagullBase64.js'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  mixins: [PrintAllCovers],
  methods: {
    async formatTemplate(orders) {
      var shippinglist = this.$store.state.shippinglist
      var vm = this

      var shippingtypeimg = await this.myShippingImg()
      var receiptText = vm.$t('Receipt')

      var data = orders.map((el, i) => {
        const kerryTracking = el.trackingno || '-'
        var productdetail
        var payment = vm.$t('Credit card')
        if (el.payment == 'banktransfer' || el.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (el.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (el.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (el.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }
        var formatproductdetail = []
        try {
          productdetail = JSON.parse(el.productdetail)

          formatproductdetail = productdetail.map((val, i) => {
            return [
              {
                text: i + 1 + '. ' + val.name + ` x ${val.quantity} (${val.option})`,
                style: { fontSize: vm.regularsize },
                bold: true
              }
            ]
          })
        } catch (error) {
          console.log(error)
          productdetail = []
          formatproductdetail = [{ text: el.productdetail }]
        }
        return [
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    image: shippingtypeimg['kerry_charge'],
                    border: [true, true, false, true],
                    borderColor: ['#000000', '#000000', '#000000', '#000000'],
                    width: 90,
                    alignment: 'center'
                  },
                  {
                    image: seagull.icon,
                    border: [false, true, true, true],
                    borderColor: ['#000000', '#000000', '#000000', '#000000'],
                    width: 90,
                    alignment: 'center',
                    margin: [0, 5, 0, 5]
                  }
                ]
              ]
            }
          },
          {
            margin: [0, 0, 0, 6],
            table: {
              widths: ['*', 40],
              body: [
                [
                  {
                    text: kerryTracking,
                    alignment: 'center',
                    fontSize: 22,
                    bold: true,
                    margin: [0, 8, 0, 8]
                  },
                  { qr: kerryTracking, fit: '50', alignment: 'center' }
                ]
              ]
            }
          },
          {
            // width: 225,
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Sender') + '\n', style: 'header' },
                      {
                        text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                          vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                        } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                        style: 'paragraph',
                        bold: true
                      }
                    ],
                    style: 'container',
                    lineHeight: 1
                  }
                ]
              ]
            }
          },
          {
            margin: [0, 6, 0, 0],
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Receiver') + '\n', style: 'header' },
                      {
                        text: vm.noSpaceAndSpecial(el.nameaddress),
                        style: 'paragraph',
                        bold: true
                      }
                    ],
                    style: 'container'
                  }
                ]
              ]
            }
          },
          {
            margin: [0, 10, 0, 0],
            columns: [
              {
                text: receiptText,
                style: 'receipt'
              }
            ]
          },
          {
            table: {
              widths: [50, 162, 93, 55],
              lineHeight: 0.5,
              body: [
                [
                  {
                    text: vm.$t('Order No:'),
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  { text: el.id, style: { fontSize: vm.regularsize }, bold: true },
                  {
                    text: vm.selectedBot.theme ? 'Delivery Date: ' : vm.$t('Order Date: '),
                    style: { alignment: 'right', fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    text: moment(el.timestamp).format('DD/MM/YYYY'),
                    style: { alignment: 'right', fontSize: vm.regularsize },
                    bold: true
                  }
                ]
              ]
            },
            layout: {
              hLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              },
              vLineWidth: function (i, node) {
                return 0
              },
              hLineWidth: function (i, node) {
                return 0
              }
            }
          },
          {
            table: {
              widths: [200, 175],
              body: [
                [
                  {
                    text: vm.$t('Shipping option'),
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    columns: [
                      {
                        text: vm.$t(
                          el.shippingtype && el.shippingtype.includes('other')
                            ? shippinglist[el.shippingtype][4]
                            : el.shippingtype
                        ),
                        width: '*',
                        style: { alignment: 'right', fontSize: vm.regularsize },
                        margin: [0, 0, 10, 0],
                        bold: true
                      },
                      {
                        image: shippingtypeimg[el.shippingtype]
                          ? shippingtypeimg[el.shippingtype]
                          : shippingtypeimg['other_charge'],
                        width: 40,
                        style: { alignment: 'right', fontSize: vm.regularsize - 3 }
                      }
                    ]
                  }
                ],
                [
                  {
                    text: vm.$t('Payment Method'),
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    text: payment,
                    style: { alignment: 'right', fontSize: vm.regularsize },
                    bold: true
                  }
                ],
                [
                  {
                    text: vm.$t('Remark'),
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    text:
                      el.remark != null &&
                      [
                        '148831989096546',
                        '1229692217050821',
                        '135565533158593',
                        '488563718210335',
                        '799590883441878'
                      ].includes(vm.selectedBot.pageid)
                        ? el.remark.split(';;')[0]
                        : el.remark,
                    style: { alignment: 'right', fontSize: vm.regularsize },
                    bold: true
                  }
                ]
              ]
            },
            layout: {
              hLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              },
              vLineWidth: function (i, node) {
                return 0
              },
              hLineWidth: function (i, node) {
                return 0
              }
            }
          },
          {
            text: vm.$t('Product Detail'),
            margin: [0, 5, 0, 2],
            style: {
              bold: true,
              fontSize: vm.headersize
            }
          },
          {
            table: {
              widths: [
                '148831989096546',
                '1229692217050821',
                '135565533158593',
                '488563718210335',
                '799590883441878'
              ].includes(vm.selectedBot.pageid)
                ? [300, 70]
                : [370],
              body: formatproductdetail
            },
            // layout: {
            //   hLineColor: function(i, node) {
            //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
            //   },
            //   vLineColor: function(i, node) {
            //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
            //   }
            // },
            pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after'
          },
          ...(el.payment != 'cod'
            ? []
            : [
                {
                  pageBreak: i + 1 == orders.length ? '' : 'after',
                  margin: [0, 10, 0, 0],
                  table: {
                    widths: [200 + 175],
                    body: [
                      // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                      [
                        // { text: , style: { fontSize: vm.regularsize } },
                        {
                          text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                          style: { alignment: 'right', fontSize: vm.regularsize + 2 },
                          bold: true
                        }
                      ]
                    ]
                  },
                  layout: {
                    vLineWidth: function (i, node) {
                      return 0
                    },
                    hLineWidth: function (i, node) {
                      return 0
                    }
                  }
                }
              ])
        ]
      })

      return data
    },
    async printPDF(orders) {
      var data = await this.formatTemplate(orders)
      var dd = {
        content: [data],
        pageSize: 'A5',
        pageMargins: [15, 15, 15, 15],
        styles: {
          header: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize
          },
          container: {
            margin: [2, 2, 2, 2]
          },
          receipt: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        }
      }
      this.loading = false
      console.log(dd)
      pdfMake.createPdf(dd).open()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCoverSeagull.vue